import {create} from "zustand";
import {persist} from "zustand/middleware";

import {zustandPersistStorage} from "../lib/zustand-custom-store";

type ResidentContextStore = {
  selectedPropertyId: number | null;
  selectedHouseholdId: number | null;
  setSelectedContext: (propertyId: number, householdId: number) => void;
  clearContext: () => void;
};

export const useResidentContextStore = create<ResidentContextStore>()(
  persist(
    (set) => ({
      selectedPropertyId: null,
      selectedHouseholdId: null,

      setSelectedContext: (propertyId, householdId) => {
        set({
          selectedPropertyId: propertyId,
          selectedHouseholdId: householdId,
        });
      },

      clearContext: () => {
        set({
          selectedPropertyId: null,
          selectedHouseholdId: null,
        });
      },
    }),
    {
      name: "resident-context-store",
      storage: zustandPersistStorage,
      partialize: (state) => ({
        selectedPropertyId: state.selectedPropertyId,
        selectedHouseholdId: state.selectedHouseholdId,
      }),
      merge: (persistedState: unknown, currentState) => ({
        ...currentState,
        ...(persistedState as Partial<ResidentContextStore>),
      }),
    },
  ),
);

export function useStoredResidentHouseholdId() {
  return useResidentContextStore((state) => state.selectedHouseholdId);
}
